export enum ETestIds {
  MonthlyPayment = 'monthlyPayment',
  CreditSum = 'creditSum',
  TermInput = 'termInput',
  PriceInput = 'priceInput',
  RequiredAmountCash = 'requiredAmountCash',
  DownPayment = 'downPayment',
  Commission = 'commission',
  FlatPriceInDocument = 'flatPriceInDocument',
  LinkButton = 'linkButton',
}
